<template>
  <div>
    <div class="d-flex height-set-for-component">
      <table
            class="tabletable-with-border table-responsive table-scroll small-first-col table-cell-styles" style="background: transparent;width:93%;margin:15px !important;">
        <thead style="color: #eee">
          <tr style="height:40px;">
            <th scope="col"  class="text-left" style="width:50%;">
              {{$t('Path')}}
            </th>
            <th scope="col" class="text-left" style="width:50%;">
               {{$t('Catalogs')}}
            </th>
            <th scope="col" class="text-center" style="width:10%;"></th>
          </tr>
        </thead>
        <tbody class="body-half-screen">

          <tr  v-for="(value,key) in catalogDisplayMap" :key="key" :data-id="key" style="margin:0 !important;margin-top:18px !important;flex-wrap: unset;">
            <td class="text-left col-md-5" style="width:45%;max-width:45%;">
              <folder-multiselect :allowSingleSelect="true" :ref="'source'+key" :enableCatBrowser="true"
               @updatedCatalogsList="(e) => handleCatalogSelection(e,key)" :enableMultiSelect="false"
                  :setDefaultFocus="isFocusedRequired(key)"  :isOpenDropdownEventRequired="true" :selectedOptions="catalogDisplayMap[key].source_catalog" @dropDownOpened="decideOpenDirection('source'+key,key)"></folder-multiselect>
            </td>
            <td class="text-center col-md-5" style="width:45%;max-width:45%;">
              <folder-multiselect :setDefaultFocus="isFocusedRequired(key)" class="multiple-catalogs-selection" style="height:unset !important;" :allowSingleSelect="false" :getChildrenCategoryWithId="parentCatalogId" :ref="'child'+key" :enableCatBrowser="true"
               :enableMultiSelect="true" @updatedCatalogsList="(e) => hadleChildrenCatalogSelection(e,key)" @removedCatalogFromList="(e) => handleRemoveCatalogFromChildren(e,key)"
                 :isOpenDropdownEventRequired="true" :selectedOptions="catalogDisplayMap[key].required_catalogs" @dropDownOpened="decideOpenDirection('child'+key,key)"></folder-multiselect>
            </td>
            <td class="col-md-2" style="width:10%;max-width:10%;">
                  <svg
                    v-on:click="deleteCatalogsDisplayRow(key)"
                    width="2em"
                    height="1.5em"
                    viewBox="0 0 16 16"
                    class="bi bi-trash delete-btn"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <div class="add-more-row-wrapper">
          <div class="addmore">
              <svg
                width="2em"
                height="2em"
                viewBox="0 0 16 16"
                class="bi bi-plus-square mt-4"
                fill="currentColor"
                @click="enableNewRow()"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M14 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
                />
                <path
                  fill-rule="evenodd"
                  d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
                />
              </svg>
           </div>
           <div class="save-btn-wrapper" v-if="Object.keys(catalogDisplayMap).length">
                 <svg @click="saveCatalogsDisplay()" xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" fill="currentColor" class="bi bi-check-square" viewBox="0 0 16 16">
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                  <title>{{$t('Save')}}</title>
                </svg>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import FolderAutoComplete from "../categories/CatalogMultiselectDropdown.vue";
import Constants from "../../components.constants.js";
import {mapMutations,mapActions} from "vuex";
import Utils from "../../components.utils.js";
//import {NotifierConstants} from "../../components.constants.js";
//import Multiselect from 'vue-multiselect';

export default {
  props: ["selectedUserGroupID","newUserGroup", "selectedUserGroupInfo"],
    data() {
      return {
        dropdownOpenDirection:"below",
        browseWorkspaceList:[Constants.WORKSPACE_CATALOG],
        display_catalogs:[],
        catalogDisplayMap:{},
        lastOPenedRowId:null,
      };
    },
    methods: {
      checkIfLastWasEmpty(message="New row is already added."){
         if(!this.catalogDisplayMap[this.lastOPenedRowId]) return false;
         if(!this.catalogDisplayMap[this.lastOPenedRowId].source_catalog && !this.catalogDisplayMap[this.lastOPenedRowId].required_catalogs.length){
            alert(message);
            return true;
         }
         return false;
      },
      enableNewRow(){
        let isRowAlreadyAdded = this.checkIfLastWasEmpty();
        if(isRowAlreadyAdded) return;
        let id = Utils.getUUID();
        this.catalogDisplayMap[id] = {source_catalog:"",required_catalogs:[]};
        this.$forceUpdate();
        this.lastOPenedRowId = id;
      },
      handleCatalogSelection(catalog,id){
        console.log(`[handleCatalogSelection]`,catalog);
        this.catalogDisplayMap[id]["source_catalog"] = catalog;
      },

      hadleChildrenCatalogSelection(catalog,id){
          console.log(`[hadleChildrenCatalogSelection]`,catalog);
          if(this.catalogDisplayMap[id] && !Object.prototype.hasOwnProperty.call(this.catalogDisplayMap[id],'required_catalogs')) 
              this.catalogDisplayMap[id]['required_catalogs'] = [];
          let idx = this.catalogDisplayMap[id]["required_catalogs"].findIndex((el)=> el._id == catalog._id);
          if(idx <= -1){
             this.catalogDisplayMap[id]["required_catalogs"].push(catalog);
          }
      },

      handleRemoveCatalogFromChildren(catalog,id){
          console.log(`[handleRemoveCatalogFromChildren]`,catalog);
          if(this.catalogDisplayMap[id] && 
              Object.prototype.hasOwnProperty.call(this.catalogDisplayMap[id],'required_catalogs')){
              this.catalogDisplayMap[id]["required_catalogs"] = this.catalogDisplayMap[id]["required_catalogs"].filter((el) => el._id != catalog._id);
          }
      },

      getPayloadTransformedData(){
          let data = [];
          for(let key in this.catalogDisplayMap){
             if(!this.catalogDisplayMap[key].source_catalog && !this.catalogDisplayMap[key].required_catalogs.length) continue;
             let source = String(this.catalogDisplayMap[key].source_catalog.parent_id_path) + "/" + this.catalogDisplayMap[key].source_catalog._id;
             let children = this.catalogDisplayMap[key].required_catalogs.map((el)=> {
                 return String(el.parent_id_path) + "/" + el._id;
             });
             data.push({
               source_catalog: source,
               required_catalogs: children,
             });
          }
          console.log(`[getPayloadTransformedData]`,data);
          return data;
      },
      getDeletedCatalogsDisplayPayload(catalogsDisplayMap = {}){
          let data = [];
          for(let key in catalogsDisplayMap){
             if(!catalogsDisplayMap[key].source_catalog && !catalogsDisplayMap[key].required_catalogs.length) continue;
             let source = String(catalogsDisplayMap[key].source_catalog.parent_id_path) + "/" + catalogsDisplayMap[key].source_catalog._id;
             let children = catalogsDisplayMap[key].required_catalogs.map((el)=> {
                 return String(el.parent_id_path) + "/" + el._id;
             });
             data.push({
               source_catalog: source,
               required_catalogs: children,
             });
          }
          console.log(`[getPayloadTransformedData]`,data);
          return data;
      },

      saveCatalogsDisplay(){
        let isRowAlreadyAdded = this.checkIfLastWasEmpty("Empty row");
        if(isRowAlreadyAdded) return;
        let payload = {"display_catalogs":this.getPayloadTransformedData()};
        payload.params = { _id: this.selectedUserGroupID };
        console.log(payload);
        this.updateExistingUserGroup(payload).then((data)=>{
              if(Utils.isAcceptedStatusCode(data.statusCode)) {
                  this.$toast.success(data.message);
              }else{
                  this.$toast.error(data.message);
              }
        });
      },

      checkIfRowisEmpty(id){
          if(this.catalogDisplayMap[id]){
              let data = this.catalogDisplayMap[id];
              if(!data.source_catalog && !data.required_catalogs.length){
                  delete this.catalogDisplayMap[id];
                  this.$forceUpdate();
                  return true;
              }
          }
          return false;
      },
      
      deleteCatalogsDisplayRow(id){
        let isRowEmpty = this.checkIfRowisEmpty(id);
        if(isRowEmpty) return;
        if (confirm(`Are you sure you want to delete the selected row ?`)) {
          if(this.catalogDisplayMap[id]){
              let data = JSON.parse(JSON.stringify(this.catalogDisplayMap)); // deep clone
              delete  data[id];
              let payload = {"display_catalogs":this.getDeletedCatalogsDisplayPayload(data)};
              payload.params = { _id: this.selectedUserGroupID };
              console.log(`[deleteCatalogsDisplayRow]`,payload);
              this.updateExistingUserGroup(payload).then((data)=>{
                  if(Utils.isAcceptedStatusCode(data.statusCode)) {
                      delete this.catalogDisplayMap[id];
                      this.$forceUpdate();
                      this.$toast.success(data.message);
                  }else{
                      this.$toast.error(data.message);
                  }
              });
          }
        }
      },

    decideOpenDirection(ref,id){
      this.$nextTick(()=>{
        let top = document.querySelector(`tr[data-id="${id}"]`).getBoundingClientRect().top;
        let pos = window.innerHeight - top;
        let multiselectComp = this.$refs[ref][0];
        if(pos < 300){
           multiselectComp.openDirection = 'above';
        }else{
            multiselectComp.openDirection = 'below';
        }
      })
    },
    ...mapActions("assets",["getCategoryTreefromId"]),
    ...mapActions("userGroups",["getUserGroupInfoFromServer","updateExistingUserGroup"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"])
    },
    created(){ 
        if(this.selectedUserGroupInfo && Object.prototype.hasOwnProperty.call(this.selectedUserGroupInfo,'display_catalogs')){
            this.display_catalogs = this.selectedUserGroupInfo.display_catalogs;
            for(let i = 0; i < this.display_catalogs.length; i++){
                let id = Utils.getUUID();
                this.catalogDisplayMap[id] = {};
                this.catalogDisplayMap[id]['required_catalogs'] = this.display_catalogs[i].required_catalogs_info;
                this.catalogDisplayMap[id]['source_catalog'] = this.display_catalogs[i].source_catalog_info;
            }
         }
      },
    components: {
      "folder-multiselect": FolderAutoComplete,
    //   "Multiselect":Multiselect
    },

    computed:{
       isFocusedRequired(){
         return (id) => id === this.lastOPenedRowId;
       }
    }
};

</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;

.showmodal {
  display: block;
}

.table-scroll {
    /*width:100%; */
    /* Decoration */
    border-spacing: 0;
    margin: 0px 15px;
    border: $secondary-border-color !important;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            border: $secondary-border-color !important;
            th {
            position: sticky;
            top: -1px;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr:hover{
                background: $bg-color-on-hover !important;
            }
        }
    }


    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:16px 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }


svg {
  color: #666666;
}

svg:hover {
  color: $text-color;
}

.delete-btn {
  visibility: hidden;
}
.body-half-screen tr:hover .delete-btn {
  visibility: visible;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.height-set-for-component {
  height: calc(100vh - 130px);
  overflow: auto;
}

::v-deep{
  .multiselect{
        width:87% !important;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:70%;
      margin: 0;
      height: unset !important;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
            // border: 1px solid #292828 !important;
            border: $border-color !important;
            display: block;
            background: $secondary-background-color;
            width: 100%;
            max-height: 245px !important;
            overflow: auto;
            border: $border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color!important;
    }
    .multiselect__tags {
        background: transparent !important;
    }
    .multiselect__content-wrapper::-webkit-scrollbar {
     width: 8px;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-track {
      background: #22272b !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background !important;
    }

    .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

    .modal-footer .primary-btn-style{
       width: unset !important; 
    } 

    .multiple-catalogs-selection .multiselect__tags-wrap{
           padding-bottom: 8px;
    }

    .multiple-catalogs-selection .multiselect{
        box-shadow: none !important;
    }
}

.custom-control-input{
  z-index:999;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.category-div {
    margin-inline-start: 6%;
    margin: 25px 14%;
    width: 86%;
}

.category-label {
  padding-top: 2px;
  font-weight: 600;
  display: block !important;
}
.category-head {
    float: inline-start;
    text-align: initial;
    width: 100%;
}
.display-name-path {
  word-break: break-all;
  width: 100%;
  display: inline-block;
}

.comm-input-field-style{
    background: $primary-background!important;
    height:40px;
    width: 100% !important;
    float: inline-start;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color!important;
}

.add-more-row-wrapper{
    display: flex;
    flex-direction: column;
    row-gap: 12px;
}
</style>
